// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2YAgU","boxTitle":"Qualiphy_boxTitle__1btDq","box":"Qualiphy_box__u52VZ","toggleWrap":"Qualiphy_toggleWrap__89RB0"};